'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enhance = exports.reduceFileNames = exports.Text = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _lodash = require('lodash.reduce');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Text = exports.Text = function Text(_ref) {
  var filenames = _ref.filenames;
  return _react2.default.createElement(
    'span',
    null,
    filenames
  );
};

var reduceFileNames = exports.reduceFileNames = function reduceFileNames(value) {
  return (0, _lodash2.default)(value, function (result, file) {
    return [].concat(_toConsumableArray(result), [file.name]);
  }, []).join(', ');
};

var enhance = exports.enhance = (0, _recompose.compose)((0, _recompose.setDisplayName)('Text'), (0, _recompose.setPropTypes)({
  value: _propTypes2.default.array
}), (0, _recompose.withProps)(function (_ref2) {
  var value = _ref2.value;

  return {
    filenames: reduceFileNames(value)
  };
}));

exports.default = enhance(Text);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@team-griffin/react-file-input/lib/Text.js
// module id = 924
// module chunks = 0